// @ts-check

/** @file Shared count helpers for task detail sub-navigation. */

/** @import Task from "../../frontend-models/task" */

/**
 * @typedef {object} TaskSubnavCounts
 * @property {number} assignedUsersCount Number of users assigned to the task.
 * @property {number} commentsCount Number of task comments.
 * @property {number} timelogsCount Number of task timelogs.
 */

/**
 * @typedef {Record<string, true | {relationship: string}>} TaskSubnavCountConfig
 */

/**
 * Builds the task count query config required by every task subnav.
 * @returns {TaskSubnavCountConfig} Count config for `Task.withCount(...)`.
 */
export function taskSubnavCountConfig() {
  return {
    timelogs: true,
    comments: true,
    assignedUsersCount: {relationship: "taskAssignedUsers"}
  }
}

/**
 * Returns zero counts before a task count query has loaded.
 * @returns {TaskSubnavCounts} Related-record counters initialized to zero.
 */
export function emptyTaskSubnavCounts() {
  return {
    assignedUsersCount: 0,
    commentsCount: 0,
    timelogsCount: 0
  }
}

/**
 * Reads task subnav count props from a counted task query result.
 * @param {Task} task Loaded task with `taskSubnavCountConfig()`.
 * @returns {TaskSubnavCounts} Counts for `TaskSubnav`.
 */
export function taskSubnavCountsFromTask(task) {
  return {
    assignedUsersCount: task.readCount("assignedUsersCount"),
    commentsCount: task.readCount("commentsCount"),
    timelogsCount: task.readCount("timelogsCount")
  }
}
